import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import _ from "lodash";
import { Row, Col } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  updateAppstoreLogoLocally,
  updateAppstoreOtherImages,
  addAppstoreData,
  updateAppstoreData,
  fetchappstoreDetails,
} from "SettingActions";
import {
  COMMON_FAIL_MESSAGE,
  validateEmail,
  validateUrl,
  BASE_IMAGES_URL,
} from "Constants";
import InlineCropper from "./appstore-image-cropper";
import ImageCropper from "ImageCropper";
import LocaleStrings from "Languages";
import MaxCharacterObject from "MaxCharacterObject";

var MAXLENOBJ = {};
class WhiteLevelForm extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      count: 0,
      logoAppstore: "",
      appstoreLogoReset: false,
      appstoreLogoAvailableLocally: false,
      appstoreLogoAvailableOnDrop: false,
      otherImagesUpdated: false,
      imagePreviewUrl: "",
      coverimageAvailableLocally: false,
      coverimageAvailableOnDrop: false,
      coverimagePreviewUrl: "",
    };
  }

  componentDidMount() {
    //console.log("clientid", this.props.user.clientid);
    this.props.fetchappstoreDetails(
      this.props.session,
      this.props.user.clientid
    );
    MAXLENOBJ = MaxCharacterObject.dashboard.accountsettings.appstore;
  }

  onTextChange = (event) => {
    var content = event.target.value;
    var count = content.length;

    this.setState({ count });
  };

  appstoreLogoAvailableOnDrop = (available) => {
    if (available !== undefined)
      this.setState({ appstoreLogoAvailableOnDrop: available });
  };

  onDrop = (files) => {
    this.setState({ logoAppstore: files, appstoreLogoReset: true });
    this.props.change("applogo", files);
    this.props.updateAppstoreLogoLocally(files);
  };

  onAppstoreLogoAvailable = (available) => {
    if (available !== undefined)
      this.setState({
        appstoreLogoAvailableLocally: available,
        appstoreLogoAvailableOnDrop: available,
      });
  };

  onOtherImagesDrop = (index, files) => {
    let { appstoreOtherImages } = this.props;

    let otherImagesList = appstoreOtherImages;

    otherImagesList[index].image = files;

    this.setState({ otherImagesUpdated: true });

    this.props.change("otherimages", JSON.stringify(otherImagesList));
    this.props.updateAppstoreOtherImages(otherImagesList);
  };

  onAppstoreOtherImagesAvailable = (available) => {
    // if(available !== undefined)
    //     this.setState({appstoreLogoAvailableLocally:available, appstoreLogoAvailableOnDrop: available});
  };

  appstoreOtherImagesAvailableOnDrop = (available) => {
    // if(available !== undefined)
    //     this.setState({appstoreLogoAvailableLocally:available, appstoreLogoAvailableOnDrop: available});
  };

  otherImages = () => {
    let { initialValues, appstoreOtherImages } = this.props;
    let otherImagesList = appstoreOtherImages;

    return _.map(otherImagesList, (item, index) => {
      //   var appstoreImagePreview = "";
      //   if (item && item.image) {
      //     appstoreImagePreview = `${BASE_IMAGES_URL}/${item.image}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
      //   }

      //console.log("file", file);
      var filePreview = "";
      var fileOld = true;
      if (item && item.image) {
        var file = item.image;
        var n = file.search(";base64,");
        if (n > 0) {
          fileOld = false;
          filePreview = file;
        } else {
          fileOld = true;
          filePreview = `${BASE_IMAGES_URL}/${file}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}&download=true`;
        }
      }
      return !this.props.editMode ? (
        <ImageCropper
          displaySize={{ width: 165, height: 357 }} // For image display style
          requiredSize={{ width: 1290, height: 2796 }} // For image size required validation
          cropperSize={{ width: 160, height: 347 }} // Cropper display size. Note its add 50px for padding
          marginBottom={25}
          border={10}
          onImageSave={this.onOtherImagesDrop.bind(this, index)}
          onImageChange={this.onImageChange}
          imagepath={filePreview}
          imageType="jpg"
          className="drop-zone-area-custom-image"
          insideImage="../../style/images/dummy-image-fill@3x.png"
          insideImageStyle={{
            width: 36,
            height: 36,
          }}
          insideText="Drag and Drop or Click here to upload image. Image size must be 1290x2796 px."
        />
      ) : fileOld ? (
        <img src={filePreview} />
      ) : (
        ""
      );
    });
  };

  onFormSubmit(values) {
    let { initialValues, user } = this.props;
    let {
      appstoreLogoAvailableLocally,
      otherImagesUpdated,
      coverimageAvailableLocally,
    } = this.state;

    this.setState({ loading: true });

    if (!this.props.editMode) {
      let clientid = user.clientid;
      values.clientid = clientid;
      // 1st Insert
      this.props.addAppstoreData(
        this.props.session,
        values,
        appstoreLogoAvailableLocally,
        otherImagesUpdated,
        clientid,
        coverimageAvailableLocally,
        (response) => {
          this.setState({ loading: false });

          if (response.success) {
            this.props.showSuccess(LocaleStrings.appstore_setting_form_success);
            this.setState({
              logoAppstore: "",
              appstoreLogoReset: false,
              appstoreLogoAvailableLocally: false,
              otherImagesUpdated: false,
            });
            if (initialValues) {
              this.props.change("applogo", initialValues.applogo);
              this.props.change("otherimages", initialValues.otherimages);
            }
          } else {
            this.props.showError(COMMON_FAIL_MESSAGE);
          }
        }
      );
    } else {
      // Rest Insert
      values.version = values.version + 1;
      delete values.appstoreid;
      // console.log("values", values);
      // console.log("appstoreLogoAvailableLocally", appstoreLogoAvailableLocally);
      // console.log("otherImagesUpdated", otherImagesUpdated);
      //debugger;
      this.props.addAppstoreData(
        this.props.session,
        values,
        appstoreLogoAvailableLocally,
        otherImagesUpdated,
        (response) => {
          this.setState({ loading: false });

          if (response.success) {
            this.props.showSuccess(LocaleStrings.appstore_setting_form_success);
            this.setState({
              logoAppstore: "",
              appstoreLogoReset: false,
              appstoreLogoAvailableLocally: false,
              otherImagesUpdated: false,
            });
            if (initialValues) {
              this.props.change("applogo", initialValues.applogo);
              this.props.change("otherimages", initialValues.otherimages);
            }
          } else {
            this.props.showError(COMMON_FAIL_MESSAGE);
          }
        }
      );
    }
  }

  onImageSave = (img) => {
    // console.log("img", img);
    this.setState({
      imagePreviewUrl: img == "" ? "" : img,
      appstoreLogoAvailableLocally: img == "" ? false : true,
    });
    this.props.autofill("applogo", img == "" ? "" : img);
  };

  onCoverImageSave = (img) => {
    //console.log("img", img);
    this.setState({
      coverimagePreviewUrl: img == "" ? "" : img,
      coverimageAvailableLocally: img == "" ? false : true,
    });
    this.props.autofill("coverimage", img == "" ? "" : img);
  };

  onImageChange = (imageAvailable) => {};

  render() {
    var {
      handleSubmit,
      invalid,
      pristine,
      submitting,
      initialValues,
      deviceSize,
      clientdataforbilling,
    } = this.props;
    var {
      appstoreLogoAvailableOnDrop,
      appstoreLogoReset,
      imagePreviewUrl,
      appstoreLogoAvailableLocally,
      coverimageAvailableLocally,
      coverimagePreviewUrl,
    } = this.state;

    let categories = [
      { name: "Books", value: "Books" },
      { name: "Business", value: "Business" },
      { name: "Education", value: "Education" },
      { name: "Entertainment", value: "Entertainment" },
      { name: "Finance", value: "Finance" },
      { name: "Food & Drink", value: "Food & Drink" },
      { name: "Games", value: "Games" },
      { name: "Health & Fitness", value: "Health & Fitness" },
      { name: "Lifestyle", value: "Lifestyle" },
      { name: "Magazines & Newspapers", value: "Magazines & Newspapers" },
      { name: "Medical", value: "Medical" },
      { name: "Music", value: "Music" },
      { name: "Navigation", value: "Navigation" },
      { name: "News", value: "News" },
      { name: "Photo & Video", value: "Photo & Video" },
      { name: "Productivity", value: "Productivity" },
      { name: "Reference", value: "Reference" },
      { name: "Shopping", value: "Shopping" },
      { name: "Social Networking", value: "Social Networking" },
      { name: "Sports", value: "Sports" },
      { name: "Stickers", value: "Stickers" },
      { name: "Travel", value: "Travel" },
      { name: "Utilities", value: "Utilities" },
      { name: "Weather", value: "Weather" },
    ];

    if (
      initialValues &&
      initialValues.applogo &&
      !appstoreLogoAvailableLocally
    ) {
      imagePreviewUrl = `${BASE_IMAGES_URL}/${initialValues.applogo}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
      appstoreLogoAvailableOnDrop = true;
    }

    if (
      initialValues &&
      initialValues.coverimage &&
      !coverimageAvailableLocally
    ) {
      coverimagePreviewUrl = `${BASE_IMAGES_URL}/${initialValues.coverimage}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
    }

    return (
      <div className="panel noborder-panel">
        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - 71 }}
        >
          <Row>
            <Col lg={8} md={10} sm={12}>
              <h4>{LocaleStrings.appstore_setting_form_info_text}</h4>
            </Col>
            <Col lg={8} md={10} sm={12}>
              <form onSubmit={handleSubmit(this.onFormSubmit.bind(this))}>
                <Field
                  name="displayname_appstore"
                  label={
                    LocaleStrings.appstore_setting_form_label_display_name_in_appstore
                  }
                  placeholder={
                    LocaleStrings.appstore_setting_form_ph_display_name_in_appstore
                  }
                  type="text"
                  mandatory="true"
                  labelposition={LABEL_POSITION_TOP}
                  component={this.renderFieldText}
                  maxlength={
                    MAXLENOBJ.displayname_appstore
                      ? MAXLENOBJ.displayname_appstore
                      : ""
                  }
                  disabled={this.props.editMode}
                />
                <Field
                  name="displayname_downloadedapp"
                  label={
                    LocaleStrings.appstore_setting_form_label_display_name_ondownloded_app
                  }
                  placeholder={
                    LocaleStrings.appstore_setting_form_ph_display_name_ondownloded_app
                  }
                  type="text"
                  mandatory="true"
                  labelposition={LABEL_POSITION_TOP}
                  component={this.renderFieldText}
                  maxlength={
                    MAXLENOBJ.displayname_downloadedapp
                      ? MAXLENOBJ.displayname_downloadedapp
                      : ""
                  }
                  disabled={this.props.editMode}
                />
                <Field
                  name="short_description"
                  label={
                    LocaleStrings.appstore_setting_form_label_appstore_short_description
                  }
                  placeholder={
                    LocaleStrings.appstore_setting_form_ph_appstore_short_description
                  }
                  type="text"
                  mandatory="true"
                  labelposition={LABEL_POSITION_TOP}
                  component={this.renderFieldText}
                  maxlength={
                    MAXLENOBJ.short_description
                      ? MAXLENOBJ.short_description
                      : ""
                  }
                  disabled={this.props.editMode}
                />
                <Field
                  name="description"
                  label={
                    LocaleStrings.appstore_setting_form_label_appstore_description
                  }
                  placeholder={
                    LocaleStrings.appstore_setting_form_ph_appstore_description
                  }
                  mandatory="true"
                  labelposition={LABEL_POSITION_TOP}
                  component={this.renderFieldTextarea}
                  //onChange={this.onTextChange}
                  maxlength={MAXLENOBJ.description ? MAXLENOBJ.description : ""}
                  disabled={this.props.editMode}
                />
                <Field
                  name="privacypolicyurl"
                  label={
                    LocaleStrings.appstore_setting_form_label_privacy_policy_url
                  }
                  placeholder={
                    LocaleStrings.appstore_setting_form_ph_privacy_policy_url
                  }
                  type="text"
                  mandatory="true"
                  labelposition={LABEL_POSITION_TOP}
                  component={this.renderFieldText}
                  disabled={this.props.editMode}
                />
                <Field
                  name="termsconditionsurl"
                  label={
                    LocaleStrings.appstore_setting_form_label_terms_conditions_url
                  }
                  placeholder={
                    LocaleStrings.appstore_setting_form_ph_terms_conditions_url
                  }
                  type="text"
                  mandatory="true"
                  labelposition={LABEL_POSITION_TOP}
                  component={this.renderFieldText}
                  disabled={this.props.editMode}
                />
                <Field
                  name="supportemail"
                  label={
                    LocaleStrings.appstore_setting_form_label_support_email
                  }
                  placeholder={
                    LocaleStrings.appstore_setting_form_ph_support_email
                  }
                  type="text"
                  mandatory="true"
                  labelposition={LABEL_POSITION_TOP}
                  component={this.renderFieldText}
                  disabled={this.props.editMode}
                />
                <Field
                  name="supporturl"
                  label={LocaleStrings.appstore_setting_form_label_support_url}
                  placeholder={
                    LocaleStrings.appstore_setting_form_ph_support_url
                  }
                  type="text"
                  mandatory="true"
                  labelposition={LABEL_POSITION_TOP}
                  component={this.renderFieldText}
                  disabled={this.props.editMode}
                />
                <Field
                  name="websiteurl"
                  label={LocaleStrings.appstore_setting_form_label_website_url}
                  placeholder={
                    LocaleStrings.appstore_setting_form_ph_website_url
                  }
                  type="text"
                  mandatory="true"
                  labelposition={LABEL_POSITION_TOP}
                  component={this.renderFieldText}
                  disabled={this.props.editMode}
                />
                <Field
                  name="keywords"
                  label={LocaleStrings.appstore_setting_form_label_keywords}
                  placeholder={LocaleStrings.appstore_setting_form_ph_keywords}
                  type="text"
                  mandatory="true"
                  labelposition={LABEL_POSITION_TOP}
                  component={this.renderFieldText}
                  disabled={this.props.editMode}
                />
                <div className="form-group row">
                  <div className="col-md-12 appstore-keywords">
                    - {LocaleStrings.appstore_setting_text_warning_add_keywords}
                  </div>
                </div>
                <Field
                  name="category"
                  label={LocaleStrings.appstore_setting_form_label_category}
                  placeholder={LocaleStrings.appstore_setting_form_ph_category}
                  mandatory="true"
                  type="select"
                  labelposition={LABEL_POSITION_TOP}
                  component={this.renderSelect}
                  opts={categories}
                  disabled={this.props.editMode}
                />
                <div className="form-group row">
                  <label className="col-md-12">
                    {LocaleStrings.appstore_setting_form_label_logo}
                    <span className="label-mandatory">*</span>
                  </label>
                  <div className="col-sm-12 col-sm-offset-0 imgPreview">
                    {!this.props.editMode ? (
                      <>
                        <ImageCropper
                          displaySize={{ width: 270, height: 270 }} // For image display style
                          requiredSize={{ width: 1024, height: 1024 }} // For image size required validation
                          cropperSize={{ width: 250, height: 250 }} // Cropper display size. Note its add 50px for padding
                          border={10}
                          onImageSave={this.onImageSave}
                          onImageChange={this.onImageChange}
                          imagepath={imagePreviewUrl}
                          imageType="jpg"
                          className="drop-zone-area-custom-image"
                          insideImage="../../style/images/dummy-image-fill@3x.png"
                          insideImageStyle={{
                            width: 36,
                            height: 36,
                          }}
                          insideText="Drag and Drop or Click here to upload image. Image size must be 1024x1024 px."
                        />
                        <Field name="applogo" component="input" type="hidden" />
                      </>
                    ) : (
                      <img
                        src={imagePreviewUrl}
                        style={{ width: 270, height: 270 }}
                      />
                    )}
                  </div>
                </div>

                {clientdataforbilling &&
                clientdataforbilling.length > 0 &&
                clientdataforbilling[0].plantype &&
                clientdataforbilling[0].plantype == "multiplewhitelabel" ? (
                  <>
                    <div className="form-group row">
                      <label className="col-md-12">
                        {LocaleStrings.appstore_setting_form_label_cover_image}
                      </label>
                      <div className="col-sm-12 col-sm-offset-0 imgPreview">
                        {!this.props.editMode ? (
                          <>
                            <ImageCropper
                              displaySize={{ width: 270, height: 173 }} // For image display style
                              requiredSize={{ width: 866, height: 487 }} // For image size required validation
                              cropperSize={{ width: 220, height: 123 }} // Cropper display size. Note its add 50px for padding
                              border={10}
                              onImageSave={this.onCoverImageSave}
                              onImageChange={this.onImageChange}
                              imagepath={coverimagePreviewUrl}
                              imageType="jpg"
                              className="drop-zone-area-custom-image"
                              insideImage="../../style/images/dummy-image-fill@3x.png"
                              insideImageStyle={{
                                width: 36,
                                height: 36,
                              }}
                              insideText="Drag and Drop or Click here to upload image. Image size must be 866x487 px."
                            />
                            <Field
                              name="coverimage"
                              component="input"
                              type="hidden"
                            />
                          </>
                        ) : coverimagePreviewUrl ? (
                          <img
                            src={coverimagePreviewUrl}
                            style={{ width: 270, height: 173 }}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    {!this.props.editMode || coverimagePreviewUrl ? (
                      <div className="form-group row">
                        <div className="col-md-12 appstore-keywords">
                          - {LocaleStrings.appstore_setting_note_cover_image}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  ""
                )}

                {/* <div className="form-group row">
                <label className="col-md-12">
                  {LocaleStrings.appstore_setting_form_label_images}
                </label>
                <div
                  className="col-md-12 col-sm-offset-0"
                  style={{ display: "flex", gap: 8 }}
                >
                  {this.otherImages()}
                  <Field name="otherimages" component="input" type="hidden" />
                </div>
              </div> */}
                <div className="clearfix">&nbsp;</div>
                {!this.props.editMode ? (
                  <Button
                    bsStyle=""
                    className="btn-primary"
                    loading={this.state.loading}
                    type="submit"
                    disabled={pristine || invalid || submitting}
                  >
                    {LocaleStrings.button_save}
                  </Button>
                ) : (
                  ""
                )}
              </form>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

function validate(values) {
  var errors = {};
  var displayname_appstore = values["displayname_appstore"];
  var displayname_downloadedapp = values["displayname_downloadedapp"];
  var short_description = values["short_description"];
  var description = values["description"];
  var privacypolicyurl = values["privacypolicyurl"];
  var termsconditionsurl = values["termsconditionsurl"];
  var supportemail = values["supportemail"];
  var supporturl = values["supporturl"];
  var websiteurl = values["websiteurl"];
  var keywords = values["keywords"];
  var category = values["category"];
  var applogo = values["applogo"];

  if (!displayname_appstore || displayname_appstore.trim() === "") {
    errors["displayname_appstore"] = LocaleStrings.required;
  } else if (displayname_appstore && MAXLENOBJ) {
    if (displayname_appstore.length > MAXLENOBJ.displayname_appstore) {
      errors["displayname_appstore"] =
        LocaleStrings.max_characters_left + MAXLENOBJ.displayname_appstore;
    }
  }

  if (!displayname_downloadedapp || displayname_downloadedapp.trim() === "") {
    errors["displayname_downloadedapp"] = LocaleStrings.required;
  } else if (displayname_downloadedapp && MAXLENOBJ) {
    if (
      displayname_downloadedapp.length > MAXLENOBJ.displayname_downloadedapp
    ) {
      errors["displayname_downloadedapp"] =
        LocaleStrings.max_characters_left + MAXLENOBJ.displayname_downloadedapp;
    }
  }

  if (!short_description || short_description.trim() === "") {
    errors["short_description"] = LocaleStrings.required;
  } else if (short_description && MAXLENOBJ) {
    if (short_description.length > MAXLENOBJ.short_description) {
      errors["short_description"] =
        LocaleStrings.max_characters_left + MAXLENOBJ.short_description;
    }
  }

  if (!description || description.trim() === "") {
    errors["description"] = LocaleStrings.required;
  } else if (description && MAXLENOBJ) {
    if (description.length > MAXLENOBJ.description) {
      errors["description"] =
        LocaleStrings.max_characters_left + MAXLENOBJ.description;
    }
  }

  if (!privacypolicyurl || privacypolicyurl.trim() === "") {
    errors["privacypolicyurl"] = LocaleStrings.required;
  } else if (privacypolicyurl && !validateUrl(privacypolicyurl)) {
    errors["privacypolicyurl"] = LocaleStrings.invalid_url;
  }

  if (!termsconditionsurl || termsconditionsurl.trim() === "") {
    errors["termsconditionsurl"] = LocaleStrings.required;
  } else if (termsconditionsurl && !validateUrl(termsconditionsurl)) {
    errors["termsconditionsurl"] = LocaleStrings.invalid_url;
  }

  if (!supportemail || supportemail.trim() === "") {
    errors["supportemail"] = LocaleStrings.required;
  } else if (supportemail && !validateEmail(supportemail)) {
    errors["supportemail"] = LocaleStrings.invalid_email;
  }

  if (!supporturl || supporturl.trim() === "") {
    errors["supporturl"] = LocaleStrings.required;
  } else if (supporturl && !validateUrl(supporturl)) {
    errors["supporturl"] = LocaleStrings.invalid_url;
  }

  if (!websiteurl || websiteurl.trim() === "") {
    errors["websiteurl"] = LocaleStrings.required;
  } else if (websiteurl && !validateUrl(websiteurl)) {
    errors["websiteurl"] = LocaleStrings.invalid_url;
  }

  if (!keywords || keywords.trim() === "") {
    errors["keywords"] = LocaleStrings.required;
  }

  if (!category) {
    errors["category"] = LocaleStrings.required;
  }

  if (!applogo) {
    errors["applogo"] = LocaleStrings.required;
  }

  return errors;
}

function mapStateToProps(state) {
  var initVals = null;
  var toEdit = false;

  if (
    state.appstoreDetails &&
    state.appstoreDetails.resource &&
    state.appstoreDetails.resource.length > 0
  ) {
    initVals = state.appstoreDetails.resource[0];
    toEdit = true;
  }

  return {
    session: state.session,
    // appstoreDetails: state.appstoreDetails,
    initialValues: initVals,
    editMode: toEdit,
    appstoreOtherImages: state.appstoreOtherImages,
    deviceSize: state.deviceSize,
    user: state.user,
    clientdataforbilling: state.clientdataforbilling,
  };
}

export default connect(mapStateToProps, {
  updateAppstoreLogoLocally,
  updateAppstoreOtherImages,
  addAppstoreData,
  updateAppstoreData,
  showError,
  showSuccess,
  fetchappstoreDetails,
})(
  reduxForm({
    form: "SaveAppStoreDetailsForm",
    validate,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(WhiteLevelForm)
);
